import { Outlet } from "react-router-dom";
import HomePage from "pages/website/HomePage";
import AboutPage from "pages/website/AboutPage";
import DonateItem from "pages/website/DonateItem";
import DonatePage from "pages/website/DonatePage";
import ProjectPage from "pages/website/ProjectPage";
import NGOSettings from "pages/dashboard/ngo/NGOSettings";
import NGODashboard from "pages/dashboard/ngo/NGODashboard";
import NGODonations from "pages/dashboard/ngo/NGODonations";
import DonorDashboard from "pages/dashboard/donor/Dashboard";
import SingleProject from "features/ProjectPage/SingleProject";
import NGOTransations from "pages/dashboard/ngo/NGOTransations";
import NGOProjects from "pages/dashboard/ngo/Projects/NGOProjects";
import NGOProjectCreate from "pages/dashboard/ngo/Projects/NGOProjectCreate";
import ConnectProjectSelect from "features/DonateItemPage/connect-project/Select";
import ProjectDonations from "features/ngo/projects/ProjectDonations/ProjectDonations";
import DonateItemsDropoff from "features/DonateItemPage/connect-project/Dropoff";
import NotFound from "pages/NotFound";
import ForgotPassword from "pages/auth/ForgotPassword";
import ResetPassword from "pages/auth/ResetPassword";
import DonateInfo from "features/DonateItemPage/DonateInfo";
import DonateSuccess from "features/DonateItemPage/Success";
import SpecificProject from "features/DonateItemPage/specific-project/SpecificProject";
import DonorLogin from "pages/auth/Donor/Login";
import DonorSignup from "pages/auth/Donor/Signup";
import NGOLogin from "pages/auth/NGO/Login";
import NgoSignup from "pages/auth/NGO/signup/index";
import AdminLogin from "pages/auth/admin/Login";
import ContactPage from "pages/website/ContactPage";

export const donorRoutes = [
  {
    path: "/donor",
    element: <DonorDashboard />,
  },
];

export const ngoRoutes = [
  {
    path: "ngo/*",
    element: <Outlet />,
    children: [
      {
        path: "dashboard",
        element: <NGODashboard />,
      },
      {
        path: "settings",
        element: <NGOSettings />,
      },
      {
        path: "donations",
        element: <NGODonations />,
      },
      {
        path: "transactions",
        element: <NGOTransations />,
      },
      {
        path: "projects",
        element: <NGOProjects />,
      },
      {
        path: "projects/create-project",
        element: <NGOProjectCreate />,
      },
      {
        path: "projects/:id/donations",
        element: <ProjectDonations />,
      },
    ],
  },
];

export const publicRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/projects",
    element: <ProjectPage />,
  },
  {
    path: "/donate-money",
    element: <DonatePage />,
  },
  {
    path: "/donate-items/*",
    element: <Outlet />,
    children: [
      {
        path: "/category",
        element: <DonateItem />,
      },
      {
        path: "/category/specific-project",
        element: <SpecificProject />,
      },
      {
        path: "/category/connect-project",
        element: <ConnectProjectSelect />,
      },
      {
        path: "/category/pickup",
        element: <DonateInfo />,
      },
      {
        path: "/category/drop-off",
        element: <DonateItemsDropoff />,
      },
      {
        path: "/success",
        element: <DonateSuccess />,
      },
    ],
  },
  {
    path: "projects/*",
    element: <Outlet />,
    children: [
      {
        path: ":id",
        element: <SingleProject />,
      },
    ],
  },
  {
    path: "auth/*",
    element: <Outlet />,
    children: [
      {
        path: "admin/login",
        element: <AdminLogin />,
      },
      {
        path: "ngo/login",
        element: <NGOLogin />,
      },
      {
        path: "ngo/signup",
        element: <NgoSignup />,
      },
      {
        path: "donor/login",
        element: <DonorLogin />,
      },
      {
        path: "donor/signup",
        element: <DonorSignup />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
    ],
  },
  {
    path: "reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
